import { createApp } from 'vue';
import EpubToMobiConverter from '@/Components/EpubToMobiConverter.vue';
import '@styles/app.css';

createApp(EpubToMobiConverter).mount('#epub-to-mobi-converter');
